import React from "react";
import {
  Cloud12,
  HorizontalBarChart,
  Kpi,
  LineChart23,
  PictureWall12,
  Top,
} from "./charts";

export const BrandsFocus = () => (
  <svg viewBox="0 0 108 136">
    <Kpi x={8} y={8} />
    <Kpi x={40} y={8} />
    <Kpi x={72} y={8} />

    <LineChart23 x={8} y={28} />
    <HorizontalBarChart x={72} y={28} />

    <Cloud12 x={8} y={60} />
    <PictureWall12 x={56} y={60} />

    <Top x={8} y={92} />
    <Top x={56} y={92} />

    <Top x={8} y={124} />
    <Top x={56} y={124} />
  </svg>
);
